import React from 'react';

import { Media } from '$partials/media/index.js';
import { ModuleDispatcher } from '$partials/modules/index.js';
import { PageShell } from '$partials/global/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').CareerDetailPage}
 */
const CareerDetailPage = (props) => {
    const page = props.data?.page;

    const content = page?.content || [];

    return (
        <PageShell
            banner
            footer={props.data?.footer}
            header={props.data?.header}>
            {/* Page header */}
            <div className='layout-container bg-neutral-00'>
                <div className='py-16 sm:py-40'>
                    <div className='layout-grid flex-col sm:flex-row gap-y-16 sm:gap-y-0'>
                        <div className='w-full sm:w-4/12 md:w-3/12 lg:w-3/12 layout-grid-col'>
                            <div className='sm:sticky sm:top-110'>
                                <h1 className='type-style-heading'>
                                    {page?.title}
                                </h1>

                                {page?.introduction && (
                                    <div
                                        className='rich-text type-style-heading'
                                        dangerouslySetInnerHTML={{ __html: page.introduction }} />
                                )}
                            </div>
                        </div>

                        <div className='w-full sm:w-8/12 md:w-9/12'>
                            {(page?.heading || page?.text) && (
                                <div>
                                    {/* Push heading down */}
                                    <div
                                        aria-hidden={true}
                                        className='hidden sm:block sm:w-4/9 md:w-4/9 lg:w-3/9 text-transparent type-style-heading select-none pointer-events-none'>
                                        {page?.title}
                                    </div>

                                    {page?.heading && (
                                        <p className='type-style-heading sm:w-5/8 md:w-5/9 layout-grid-col'>{page.heading}</p>
                                    )}

                                    {page?.text && (
                                        <div
                                            className='rich-text type-style-body mt-8 sm:mt-10 sm:w-4/8 md:w-4/9 layout-grid-col'
                                            dangerouslySetInnerHTML={{ __html: page.text }} />
                                    )}
                                </div>
                            )}

                            {page?.media && (
                                <div className='layout-grid-col'>
                                    <div className='mt-20 sm:mt-32 text-[0] leading-[0] tracking-normal'>
                                        <figure className={page.media.videoEmbed ? '' : 'pointer-events-none select-none'}>
                                            <Media
                                                image={page.media.image ? { ...page.media.image } : undefined}
                                                video={page.media.video ? {
                                                    autoPlay: true,
                                                    controls: false,
                                                    loop: true,
                                                    muted: true,
                                                    ...page.media.video
                                                } : undefined}
                                                videoEmbed={page.media.videoEmbed ? { ...page.media.videoEmbed } : undefined} />
                                        </figure>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Streamfield modules */}
            {content.length > 0 && (
                <div>
                    {content.map((module) => (
                        <ModuleDispatcher
                            key={module.id}
                            modulePaddingClasses='py-24 sm:py-32'
                            { ...module } />
                    ))}
                </div>
            )}
        </PageShell>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default CareerDetailPage;
